import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Collapse,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import {
  Add as AddIcon,
  Close as CloseIcon,
  CloudDownload as CloudDownloadIcon,
  CloudUpload as CloudUploadIcon,
  CloudUploadOutlined as CloudUploadOutlinedIcon,
  DeleteTwoTone as DeleteTwoToneIcon,
  ExpandMore as ExpandMoreIcon,
  Group as GroupIcon,
  HelpOutline as HelpOutlineIcon,
  Label as LabelIcon,
  PlaylistAdd as PlaylistAddIcon,
  Save as SaveIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  ZoomOutMap as ZoomOutMapIcon,
} from '@material-ui/icons';
import {
  Alert,
  AlertTitle,
} from '@material-ui/lab';
import {
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  Document,
  Page,
  pdfjs,
} from 'react-pdf';

import {
  ButtonGroup,
  DataTable,
  DynamicForm,
  Header,
  Modal,
} from 'components';
import { SelectControl } from 'components/DynamicForm/controls';
import { useTable } from 'hooks';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import Dynamicore, { SERVICES } from 'services/dynamicore';
import { dynamicSort } from 'utils/arrays';
import { getCurrentSessionData } from 'utils/aws/cognito';
import { getSignedUrl, upload } from 'utils/aws/s3';
import { v4 as uuidv4 } from 'uuid';
import {
  addSignerFormSchema,
  addSignerFormSchemaClient,
  addSignerFormSchemaRelationship,
} from 'validations/schema/forms';

import useStyles from './styles';
import {
  cleanString,
  cleanTemplate,
  DEFAULT_PROPS,
  filterValidClients,
  getSelectorTypes,
  getSignersButtonGroup,
  getStepsQuestion1,
  getStepsQuestion2,
  HEADERS,
  PROP_TYPES,
  replaceKeyInArray,
  toBase64,
  TYPE_MAP,
  updateValuesFromMapeo,
} from './constants';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function FileAndHtmlControl(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [text, setText] = useState('');
  const { t } = useTranslation('translation', {
    keyPrefix: 'views.documents_templates_edit',
  });
  const [currentError, setCurrentError] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState(null);
  const [originFile, setOriginFile] = useState(null);
  const [menuPosition, setMenuPosition] = useState(null);
  const [showSigners, setShowSigners] = useState(false);
  const [showTypeSigners, setShowTypeSigners] = useState(false);
  const [signers, setSigners] = useState([]);
  const [signatures, setSignatures] = useState([]);
  const [data, setData] = useState(null);
  const [draggingSignature, setDraggingSignature] = useState(null);
  // Estado para el zoom del PDF
  const [pdfZoom, setPdfZoom] = useState(isMobile ? 0.7 : isTablet ? 0.8 : 1.0);
  const dragOffset = useRef({
    relative_position_x: 0,
    relative_position_y: 0,
  });
  const [resizingSignature, setResizingSignature] = useState(null);
  const resizeOffset = useRef({
    relative_position_x: 0,
    relative_position_y: 0,
  });
  const [labels, setLabels] = useState(props?.defaultSignatures?.labels);
  const [labelsMatch, setLabelsMatch] = useState(
    props?.defaultSignatures?.labelsMatch,
  );
  const [fieldFunction, setFieldFunction] = useState(
    props?.defaultFunctions ?? {},
  );
  const [newLabel, setNewLabel] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [dimensions, setDimensions] = useState({});
  const [modal, setModal] = useState();
  const [modal2, setModal2] = useState();
  const [table, setTable] = useState();
  const [company, setCompany] = useState();
  const [functions, setFunctions] = useState();
  const [openFunctions, setOpenFunctions] = useState({});
  const { generateTable } = useTable({
    translate: t,
  });
  const SIGNERS_BUTTON_GROUP = getSignersButtonGroup(t);
  const [currentView, setCurrentView] = useState('list');
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [typeAddSigner, setTypeAddSigner] = useState();
  const selectorTypes = getSelectorTypes(t);
  const [selectorType, setSelectorType] = useState(t('forms.selectors.select'));
  const [selectorClients, setSelectorClients] = useState();
  const [selectorClient, setSelectorClient] = useState(
    t('forms.selectors.select'),
  );
  const [selectorRelationships, setSelectorRelationships] = useState();
  const [selectorRelationShip, setSelectorRelationShip] = useState(
    t('forms.selectors.select'),
  );
  const [isProcessing, setIsProcessing] = useState();
  const [valuesClient, setValuesClient] = useState();
  const [openSidebar, setOpenSidebar] = useState(false);
  const initialized = useRef(false);
  const [tabIndex, setTabIndex] = useState(0);
  const stepsQuestion1 = getStepsQuestion1(t);
  const stepsQuestion2 = getStepsQuestion2(t);
  const [isUploading, setIsUploading] = useState(false);
  const [showMobileAlert, setShowMobileAlert] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const stepsCompleted = [
    pdfFile !== null,
    labels && Object.keys(labels).length > 0,
    labels && Object.values(labels).every((value) => value !== ''),
    signatures && Object.keys(signatures).length > 0,
  ];

  const {
    disabled,
    error,
    events,
    label,
    name,
    size,
    settings,
    onChange,
    defaultFile,
    defaultFileName,
    defaultSignatures,
    readOnly,
  } = props;
  const { accept = [], base64 = false, multiple = false } = settings;

  let inputFile;

  const fetchData = async () => {
    const result = await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_CLIENTS).get({
      type: 'all',
    });

    if (result.values && Array.isArray(result.values)) {
      const allFields = result.values.flatMap((value) => {
        const [firstEntry] = Object.entries(value);
        let fields = [];

        if (firstEntry && Array.isArray(firstEntry)) {
          const [, entry] = firstEntry;
          if (entry) {
            fields = entry.fields || entry;
          }
        }

        if (!Array.isArray(fields)) {
          fields = [];
        }
        const groupName = value.name || Object.keys(value)?.[0];
        return fields.map((field) => ({
          id: field.value,
          val: field.value,
          name: field.name,
          groupBy: groupName,
        }));
      });
      const sortedFields = allFields.sort(dynamicSort('groupBy', 'name'));
      setData(sortedFields);
    }
  };

  //Lee el PDF y obtiene las etiquetas(Campos)
  const getTextFromPDF = async (pdfFile) => {
    const pdf = await pdfjs.getDocument(pdfFile).promise;
    let extractedStructures = [];

    const regex = /{{\s*(.*?)\s*}}/g;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageText = textContent.items.map((item) => item.str).join(' ');
      const sanitizedText = pageText
        .replace(/\{\s+/g, '{')
        .replace(/\s+\}/g, '}');

      const matches = sanitizedText.match(regex)?.map((match) => {
        return match.replace(/\s+/g, '');
      });

      if (matches) {
        extractedStructures = [...extractedStructures, ...matches];
      }
    }

    const uniqueLabels = [...new Set(extractedStructures)];
    const labelObject = uniqueLabels.reduce((acc, label) => {
      acc[label] = '';
      return acc;
    }, {});

    setLabels(labelObject);
    setLabelsMatch(labelObject);
  };

  //Carga de archivo por defecto
  const loadDefaultFile = async function () {
    if (defaultFile !== undefined) {
      setIsUploading(true);
      const renamedFile = new File([defaultFile], defaultFileName, {
        type: defaultFile.type,
        lastModified: defaultFile.lastModified,
      });

      setText(defaultFileName);

      const target = {
        name,
        value: renamedFile,
      };

      if (defaultFile.name.split('.').pop() === 'pdf') {
        const fileUrl = URL.createObjectURL(renamedFile);
        setPdfFile(fileUrl);
        setOriginFile(null);
      } else {
        setOriginFile(URL.createObjectURL(renamedFile));
        setPdfFile(await transformDocToPdf(defaultFile));
      }
      onChange({
        target,
      });

      if (events?.onChange) {
        events.onChange(target);
      }
      setIsUploading(false);
    }
  };

  //Carga de firmantes
  const loadSigners = async function () {
    const { values = [], total = 0 } = await Dynamicore(
      SERVICES.DOCUMENTS_TEMPLATES_SIGNERS,
    ).get();

    setSigners(values.sort(dynamicSort('name')));

    let updateValues = values;

    if (values.length > 0) {
      updateValues = updateValuesFromMapeo(updateValues);
    }

    setTable({
      rows: updateValues.sort(dynamicSort('name')),
      total,
    });

    const company = JSON.parse(localStorage.getItem('company'));
    setCompany(company);
  };

  const loadClients = async function () {
    const {
      values = [],
      //total = 0,
    } = await Dynamicore(SERVICES.PEOPLE_TYPES).get();

    setSelectorClients(values.sort(dynamicSort('name')));
  };

  const loadRelationships = async function () {
    const {
      values = [],
      //total = 0,
    } = await Dynamicore(SERVICES.PEOPLE_RELATIONSHIP).get({
      enabled: true,
    });
    //{
    //  enabled: true,
    //}

    setSelectorRelationships(values.sort(dynamicSort('name')));
  };

  const loadSignatures = () => {
    if (
      defaultSignatures &&
      Array.isArray(defaultSignatures.signers) &&
      defaultSignatures.signers.length > 0 &&
      defaultSignatures.dimensions &&
      typeof defaultSignatures.dimensions.x === 'number' &&
      typeof defaultSignatures.dimensions.y === 'number'
    ) {
      defaultSignatures.signers.forEach((signer) => {
        signer.relative_size_x =
          (signer.relative_size_x * defaultSignatures.dimensions.x) / 100;
        signer.relative_size_y =
          (signer.relative_size_y * defaultSignatures.dimensions.y) / 100;
        signer.relative_position_x =
          (signer.relative_position_x * defaultSignatures.dimensions.x) / 100;
        signer.relative_position_y =
          (signer.relative_position_y * defaultSignatures.dimensions.y) / 100;
      });
      setSignatures((prev) => [...prev, ...defaultSignatures.signers]);
      setDimensions(defaultSignatures.dimensions);
    }
  };

  const loadFunctions = async () => {
    try {
      const response = await Dynamicore(SERVICES.NOTIFICATIONS_FUNCTIONS).get(
        {},
      );
      setFunctions(response.values || []);
    } catch (error) {
      enqueueSnackbar('Error al cargar las funciones de notificación', {
        variant: 'error',
      });
      setFunctions([]);
    }
  };

  //Carga de archivo por defecto
  useEffect(() => {
    loadDefaultFile();
  }, [defaultFile]);

  useEffect(() => {
    loadFunctions();
    loadRelationships();
    loadClients();
    loadSigners();
    loadSignatures();
    fetchData();
  }, []);

  useEffect(() => {
    if (props.defaultFile) {
      setOpenSidebar(true);
    }
  }, [props.defaultFile]);

  useEffect(() => {
    // Para mostrar el Alert en moviles
    if (pdfFile && isMobile) {
      setShowMobileAlert(true);
    }
  }, [pdfFile, isMobile]);

  const handleAddLabel = () => {
    if (newLabel.trim() !== '' && !labels[newLabel]) {
      setLabels((prev) => ({
        ...prev,
        [newLabel]: '',
      }));
      setLabelsMatch((prev) => ({
        ...prev,
        [newLabel]: '',
      }));
      setNewLabel('');
      setIsAdding(false);
    }
  };
  //Detectar si se ha seleccionado un archivo
  const handleSelectFile = function () {
    inputFile.click();
  };

  //Drag & drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = e.dataTransfer?.files;
    if (files && files.length > 0) {
      handleFileChange({
        target: {
          files,
        },
      });
    }
  };

  const transformDocToPdf = async (file) => {
    try {
      const currentSessionData = getCurrentSessionData();
      const { Location: url } = await upload(
        `company/${company?.id}/documents/${file?.name}`,
        file,
        {
          company: company?.id,
          user: currentSessionData?.userData?.UserAttributes?.sub,
        },
        company?.id,
      );
      const { name } = await Dynamicore(SERVICES.DOC_TO_PDF).post({
        url,
      });

      return await getSignedUrl(name, 1000);
    } catch (error) {
      console.error('Error al convertir a PDF:', error);
      setCurrentError('Error al convertir el archivo a PDF');
      return URL.createObjectURL(file);
    }
  };

  //Cargar archivo
  const handleFileChange = async function ({ target: { files } }) {
    setCurrentError(false);
    setIsUploading(true);
    const names = [];
    let filesOutput = [];
    const validExt = accept.map((_) => _?.toLowerCase());

    if (!base64) {
      filesOutput = files;
    }

    try {
      for await (const file of files) {
        const ext = (file.name.split('.').pop() || '').toLowerCase();

        names.push(file.name);

        if (base64) {
          filesOutput.push(await toBase64(file));
        }

        if (!currentError && validExt.length) {
          setCurrentError(validExt.includes(ext) ? '' : 'Invalid file type');
        }

        if (file.type === 'application/pdf') {
          const fileUrl = URL.createObjectURL(file);
          setPdfFile(fileUrl);
          setOriginFile(null);
          await getTextFromPDF(fileUrl);
          handleSidebarToggle(0, true);
        } else {
          const signedUrl = await transformDocToPdf(file);
          setPdfFile(signedUrl);
          setOriginFile(URL.createObjectURL(file));
          await getTextFromPDF(signedUrl);
          handleSidebarToggle(0, true);
        }
      }
    } catch (error) {
      console.debug('handleFileChange', error);
    }

    setText(names.join(', '));

    const target = {
      name,
      value: filesOutput[0],
    };

    onChange({
      target,
    });

    if (events?.onChange) {
      events.onChange(target);
    }

    setSignatures([]);
    setIsUploading(false);
  };

  //Muestra el menu de opciones de firma al hacer clic en el PDF
  const handlePdfClick = (event) => {
    if (draggingSignature !== null) return;

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    if (dimensions.x === undefined || dimensions.y === undefined) {
      setDimensions({
        x: rect.width,
        y: rect.height,
      });
    }

    setMenuPosition({
      relative_position_x: x,
      relative_position_y: y,
    });
  };

  //Paginación de PDF (anterior)
  const handleBack = () => {
    setPageNumber((prev) => Math.max(prev - 1, 1));
  };

  //Paginación de PDF (siguiente)
  const handleNext = () => {
    setPageNumber((prev) => Math.min(prev + 1, numPages));
  };

  // Funciones para controlar el zoom del PDF
  const handleZoomIn = () => {
    setPdfZoom((prev) => Math.min(prev + 0.2, 3.0)); // Máximo 3x
  };

  const handleZoomOut = () => {
    setPdfZoom((prev) => Math.max(prev - 0.2, 0.3)); // Mínimo 0.3x
  };

  const handleResetZoom = () => {
    setPdfZoom(isMobile ? 0.7 : isTablet && !isDesktop ? 0.8 : 1.0);
  };

  //Manejo de opciones del menú de firma
  const handleMenuOption = (option, signer = null) => {
    if (option === 'addSignature') {
      //Mostrar tipos de firmantes
      setShowTypeSigners(true);
      setShowSigners(false); // Mostrar opciones de firmantes
    } else if (option === 'cancel') {
      setMenuPosition(null);
      setShowTypeSigners(false);
      setShowSigners(false);
    } else if (option === 'selectTypeSigner') {
      setShowTypeSigners(false);
      setShowSigners(true);
      setTypeAddSigner(signer.id);
    } else if (option === 'selectSigner' && signer) {
      setSignatures((prev) => {
        return [
          ...prev,
          {
            page: pageNumber,
            type: 'signature',
            signer_id: signer.id, // Mantén una referencia al firmante
            relative_size_x: 90,
            relative_size_y: 40,
            relative_position_x: menuPosition.relative_position_x,
            relative_position_y: menuPosition.relative_position_y,
            id: uuidv4(), // Genera un identificador único para cada firma
            name: signer.name,
          },
        ];
      });

      setMenuPosition(null); // Ocultar el menú después de agregar la firma
      setShowSigners(false);
      setShowTypeSigners(false);
    }
  };

  //Eliminar firma
  const handleRemoveSignature = (id) => {
    setSignatures((prev) => prev.filter((signature) => signature.id !== id));

    setMenuPosition(null);
    setShowSigners(false);
    setShowTypeSigners(false);
  };

  //Manejo de arrastre de firma
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (draggingSignature !== null) {
        setSignatures((prevSignatures) =>
          prevSignatures.map((signature) =>
            signature.id === draggingSignature
              ? {
                ...signature,
                relative_position_x: e.clientX - dragOffset.current.relative_position_x,
                relative_position_y: e.clientY - dragOffset.current.relative_position_y,
              }
              : signature,
          ),
        );
      }
    };

    const handleMouseUp = () => {
      setDraggingSignature(null);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [draggingSignature]);

  //Manejo de error
  useEffect(() => {
    setCurrentError(error);
  }, [error]);

  //Manejo de redimensionamiento de firma
  const handleResizeMouseDown = (e, signatureId) => {
    e.stopPropagation();
    setResizingSignature(signatureId);
    resizeOffset.current = {
      relative_position_x: e.clientX,
      relative_position_y: e.clientY,
    };
  };

  //Descargar PDF
  const handleDownloadPdf = () => {
    if (pdfFile) {
      const link = document.createElement('a');
      link.href = originFile || pdfFile;
      link.download = text; // Puedes cambiar el nombre del archivo aquí
      link.click();
    }
  };

  //Cerrar modal
  const handleModalClose = function () {
    setModal();
    setSelectorType(t('forms.selectors.select'));
    setSelectorClient(t('forms.selectors.select'));
    setSelectorRelationShip(t('forms.selectors.select'));
  };

  //Manejo de redimensionamiento de firma
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (resizingSignature !== null) {
        setSignatures((prevSignatures) =>
          prevSignatures.map((signature) =>
            signature.id === resizingSignature
              ? {
                ...signature,
                relative_size_x: Math.max(90, signature.relative_size_x + (e.clientX - resizeOffset.current.relative_position_x)),
                relative_size_y: Math.max(40, signature.relative_size_y + (e.clientY - resizeOffset.current.relative_position_y)),
              }
              : signature,
          ),
        );
        resizeOffset.current = {
          relative_position_x: e.clientX,
          relative_position_y: e.clientY,
        };
      }
    };

    const handleMouseUp = () => {
      setResizingSignature(null);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [resizingSignature]);

  const handleSubmitData = async function (data) {
    setIsLoading(true);
    let message,
      variant = 'success';

    try {
      if (!data?.description) {
        data.description = ' ';
      }

      data.company = company.id;
      data.mapeo = {};

      if (selectorType === 1) {
        data.cantidad = 1;
        data.type = 'default';
        data.type_id = -1;
      } else if (selectorType === 2) {
        data.mapeo = {
          name: data?.name,
          email: data?.email,
          telefono: data?.telefono,
          displayNameName: valuesClient.find((item) => item.id === data?.name)
            ?.name,
          displayNameEmail: valuesClient.find((item) => item.id === data?.email)
            ?.name,
          displayNameTelefono: valuesClient.find(
            (item) => item.id === data?.telefono,
          )?.name,
        };
        data.name = ' ';
        data.email = ' ';
        data.telefono = ' ';
        data.cantidad = 1;
        data.type = 'client';
        data.type_id = selectorClient;
      } else if (selectorType === 3) {
        data.mapeo = {
          name: data?.name,
          email: data?.email,
          telefono: data?.telefono,
          displayNameName: valuesClient.find((item) => item.id === data?.name)
            ?.name,
          displayNameEmail: valuesClient.find((item) => item.id === data?.email)
            ?.name,
          displayNameTelefono: valuesClient.find(
            (item) => item.id === data?.telefono,
          )?.name,
        };
        data.name = ' ';
        data.email = ' ';
        data.telefono = ' ';
        data.cantidad = 1;
        data.type = 'relations';
        data.type_id = selectorRelationShip;
      }

      await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_SIGNERS).post(data);

      setSelectorType(t('forms.selectors.select'));
      setSelectorClient(t('forms.selectors.select'));
      setSelectorRelationShip(t('forms.selectors.select'));

      loadSigners();
      setCurrentView('list');
      message = t('forms.messages.signer_saved');
    } catch (e) {
      message = e.message || t('forms.messages.signer_saving_error');
      variant = 'error';
    } finally {
      enqueueSnackbar(message, {
        variant,
        autoHideDuration: 3000,
      });
      setIsLoading(false);
    }
  };

  const handleRemoveSigner = async function (id) {
    let message,
      variant = 'success';

    try {
      await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_SIGNERS).delete(
        {
          id,
        },
        true,
      );

      message = t('forms.messages.signer_deleted');

      loadSigners();
      setModal2();
    } catch (error) {
      message = t('forms.messages.signer_deleting_error');
      variant = 'error';
    } finally {
      enqueueSnackbar(message, {
        variant,
      });
    }
  };

  const handleSelectorType = function (values) {
    setIsProcessing(true);

    const matchingConfig = selectorTypes.find(
      ({ id }) => id === parseInt(values.value, 10),
    );
    if (matchingConfig) {
      setSelectorType(matchingConfig?.id);
      setSelectorClient(t('forms.selectors.select'));
      setSelectorRelationShip(t('forms.selectors.select'));
    } else {
      setSelectorType(t('forms.selectors.select'));
      setSelectorClient(t('forms.selectors.select'));
      setSelectorRelationShip(t('forms.selectors.select'));
    }

    setTimeout(() => {
      setIsProcessing(false);
    }, 500);
  };

  const handleSelectorClient = async function (values) {
    setIsProcessing(true);

    const matchingConfig = selectorClients.find(
      ({ id }) => id === parseInt(values.value, 10),
    );

    if (matchingConfig) {
      setSelectorClient(matchingConfig?.id);

      try {
        const data = await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_CLIENTS).get(
          {
            type: 'client',
            type_id: matchingConfig?.id,
          },
        );

        const aux = replaceKeyInArray(data?.values, 'value', 'id');

        setValuesClient(aux.sort(dynamicSort('name')));
      } catch (error) {
        console.error('Error al cargar los datos del template:', error);
        return;
      }
    } else {
      setSelectorClient(t('forms.selectors.select'));
    }
    setIsProcessing(false);
  };

  const handleSelectorRelationships = async function (values) {
    setIsProcessing(true);

    const matchingConfig = selectorRelationships.find(
      ({ id }) => id === parseInt(values.value, 10),
    );
    if (matchingConfig) {
      setSelectorRelationShip(matchingConfig?.id);

      try {
        const data = await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_CLIENTS).get(
          {
            type: 'relationship',
            type_id: matchingConfig?.id,
          },
        );
        const allItems = data?.values.reduce((acc, item) => {
          Object.values(item).forEach((value) => {
            acc.push(...value);
          });
          return acc;
        }, []);
        const aux = replaceKeyInArray(allItems, 'value', 'id');
        setValuesClient(aux.sort(dynamicSort('name')));
      } catch (error) {
        enqueueSnackbar('Error al cargar los datos del template:', error);
        return;
      }
    } else {
      setSelectorRelationShip(t('forms.selectors.select'));
    }
    setIsProcessing(false);
  };

  const handleSidebarToggle = (index, flag = false) => {
    setTabIndex(index);
    setOpenSidebar(flag);
  };

  useEffect(() => {
    localStorage.setItem('signatures', JSON.stringify(signatures));
    localStorage.setItem('dimensions', JSON.stringify(dimensions));
    localStorage.setItem('selectedLabels', JSON.stringify(labels));
    localStorage.setItem('selectedLabelsMatch', JSON.stringify(labelsMatch));
    localStorage.setItem('selectedFunctions', JSON.stringify(fieldFunction));
  }, [signatures, labels, fieldFunction]);

  useEffect(() => {
    if (!initialized.current && labels && Object.keys(labels).length > 0) {
      const initialState = {};
      Object.keys(labels).forEach((key) => {
        const cleanedKey = cleanString(key);
        initialState[cleanedKey] = (fieldFunction[key]?.length ?? 0) > 0;
      });
      setOpenFunctions(initialState);
      initialized.current = true;
    }
  }, [labels, fieldFunction]);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          position: 'relative',
          width: '100%',
          maxWidth: '100%',
          margin: 'auto',
        }}
      >
        <Grid
          container
          sx={{
            width: '100%',
          }}
        >
          <Grid item md={openSidebar ? 8 : 12} xs={12}>
            <Box
              sx={{
                flexGrow: 1,
                transition: 'margin-right 0.3s ease',
                marginRight: openSidebar ? '16px' : '0px',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: '#f1f3f4',
                  borderRadius: '8px',
                  boxShadow: '0px 1px 3px rgba(0,0,0,0.2)',
                  padding: 1,
                }}
              >
                {/* Barra de herramientas */}
                {!readOnly && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: isMobile ? 1 : 2,
                      padding: 1,
                      flexWrap: isMobile ? 'wrap' : 'nowrap',
                      justifyContent: isMobile ? 'center' : 'flex-start',
                    }}
                  >
                    {pdfFile && (
                      <>
                        <IconButton
                          onClick={() => {
                            handleSelectFile();
                          }}
                          title={t('actions.upload_pdf')}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                        <IconButton
                          disabled={!pdfFile}
                          onClick={() => {
                            handleDownloadPdf();
                          }}
                          title={t('actions.download_pdf')}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                        <input
                          type="file"
                          accept=".pdf, .docx"
                          hidden
                          ref={inputFile}
                          onChange={handleFileChange}
                        />
                        <Divider orientation="vertical" flexItem />
                      </>
                    )}
                    <Box
                      onClick={() => handleSidebarToggle(0, true)}
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <IconButton>
                        <LabelIcon />
                      </IconButton>
                      {!isMobile && (
                        <Typography
                          variant="caption"
                          className={classes.labelBar}
                        >
                          {t('actions.label')}
                        </Typography>
                      )}
                      {isMobile && (
                        <Typography
                          variant="caption"
                          style={{
                            fontSize: '0.6rem',
                            marginTop: -4,
                          }}
                        >
                          {t('actions.label')}
                        </Typography>
                      )}
                    </Box>
                    <Box
                      onClick={() =>
                        setModal({
                          title: 'Firmantes',
                          open: true,
                          maxWidth: 'lg',
                          view: 'addSigner',
                        })
                      }
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <IconButton>
                        <GroupIcon />
                      </IconButton>
                      {!isMobile && (
                        <Typography
                          variant="caption"
                          className={classes.labelBar}
                        >
                          {t('actions.signers')}
                        </Typography>
                      )}
                      {isMobile && (
                        <Typography
                          variant="caption"
                          style={{
                            fontSize: '0.6rem',
                            marginTop: -4,
                          }}
                        >
                          {t('actions.signers')}
                        </Typography>
                      )}
                    </Box>
                    <Box
                      onClick={() => handleSidebarToggle(1, true)}
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <IconButton>
                        <HelpOutlineIcon />
                      </IconButton>
                      {!isMobile && (
                        <Typography
                          variant="caption"
                          className={classes.labelBar}
                        >
                          {t('actions.help')}
                        </Typography>
                      )}
                      {isMobile && (
                        <Typography
                          variant="caption"
                          style={{
                            fontSize: '0.6rem',
                            marginTop: -4,
                          }}
                        >
                          {t('actions.help')}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>

              {/* Alert para dispositivos móviles */}
              {isMobile && pdfFile && (
                <Collapse in={showMobileAlert}>
                  <Alert
                    severity="info"
                    onClose={() => setShowMobileAlert(false)}
                    style={{
                      marginTop: '16px',
                      borderRadius: '8px',
                      fontSize: '0.75rem',
                    }}
                  >
                    <AlertTitle
                      style={{
                        fontSize: '.85rem',
                      }}
                    >
                      💡 {t('messages.mobile_recommendation_title')}
                    </AlertTitle>
                    {t('messages.mobile_recommendation_text')}
                  </Alert>
                </Collapse>
              )}

              <Box
                sx={{
                  marginTop: 16,
                }}
              >
                <FormControl
                  disabled={disabled}
                  error={currentError}
                  fullWidth
                  size={size}
                  variant="outlined"
                >
                  {isUploading ? (
                    <div className={classes.uploadContainer}>
                      <CircularProgress
                        className={classes.uploadIcon}
                        size={90}
                      />
                      <p className={classes.uploadLabel}>
                        Obteniendo archivo...
                      </p>
                      {text ? (
                        <p className={classes.uploadTextAlt}>{text}</p>
                      ) : (
                        <p className={classes.uploadText}>
                          Por favor espera...
                        </p>
                      )}
                    </div>
                  ) : !pdfFile ? (
                    <div
                      className={classes.uploadContainer}
                      onClick={handleSelectFile}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      style={{
                        border: isDragging
                          ? '2px dashed #1976d2'
                          : '2px dashed transparent',
                        backgroundColor: isDragging
                          ? 'rgba(53, 116, 179, 0.1)'
                          : undefined,
                        transition: 'background-color 0.2s ease, border-color 0.2s ease',
                      }}
                    >
                      <input
                        accept={accept.map((_) => `.${_}`).join()}
                        hidden
                        multiple={multiple}
                        onChange={handleFileChange}
                        ref={(input) => (inputFile = input)}
                        type="file"
                      />
                      <CloudUploadOutlinedIcon className={classes.uploadIcon} />
                      <p className={classes.uploadLabel}>{label}</p>
                      {text ? (
                        <p className={classes.uploadTextAlt}>{text}</p>
                      ) : (
                        <p className={classes.uploadText}>
                          {isDragging
                            ? 'Suelta el archivo aquí'
                            : 'Presiona o arrastra un archivo'}
                        </p>
                      )}
                      {currentError && (
                        <p className={classes.errorText}>{currentError}</p>
                      )}
                    </div>
                  ) : (
                    pdfFile && (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={10} md={10}>
                          <input
                            accept={accept.map((_) => `.${_}`).join()}
                            hidden
                            multiple={multiple}
                            onChange={handleFileChange}
                            ref={(input) => (inputFile = input)}
                            type="file"
                          />
                          {currentError && (
                            <FormHelperText>{currentError}</FormHelperText>
                          )}
                        </Grid>
                      </Grid>
                    )
                  )}
                </FormControl>
              </Box>
              {/*Muestra el pdf*/}
              {!isUploading && pdfFile && (
                <Grid container justifyContent="center" >
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: isMobile ? '8px' : '16px',
                    }}
                  >
                    <div className={classes.pdfContainer}>
                      <Document
                        file={pdfFile}
                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                      >
                        <Page
                          pageNumber={pageNumber}
                          className={classes.pdfViewer}
                          onClick={handlePdfClick}
                          scale={pdfZoom}
                          onMouseMove={(e) => {
                            if (draggingSignature !== null) {
                              e.preventDefault(); // Evitar la selección de texto mientras se arrastra
                              const rect = e.target.getBoundingClientRect();
                              const x = e.clientX - rect.left;
                              const y = e.clientY - rect.top;
                              setSignatures((prev) =>
                                prev.map((sig) =>
                                  sig.id === draggingSignature ? {
                                    ...sig,
                                    relative_position_x: x,
                                    relative_position_y: y,
                                  } : sig,
                                ),
                              );
                            }
                          }}
                          onMouseUp={() => setDraggingSignature(null)}
                        >
                          {menuPosition && (
                            <div
                              style={{
                                position: 'absolute',
                                left: `${menuPosition.relative_position_x}px`,
                                top: `${menuPosition.relative_position_y}px`,
                                background: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
                                padding: '8px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                                zIndex: 10,
                              }}
                              onClick={(e) => e.stopPropagation()} // Evita que se cierre al hacer clic dentro del menú
                            >
                              {!showTypeSigners && !showSigners ? (
                                <>
                                  <p
                                    style={{
                                      margin: '0',
                                      fontSize: '20px',
                                      fontWeight: 'bold',
                                      fontFamily: 'Roboto',
                                      backgroundColor: '#bfbfbf',
                                      padding: '8px',
                                      borderRadius: '8px',
                                    }}
                                  >
                                    {t('actions.options')}
                                  </p>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleMenuOption('addSignature')
                                    }
                                    className={classes.addSignatureButton}
                                  >
                                    {t('actions.add_signature')}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleMenuOption('cancel');
                                    }}
                                    className={classes.cancelButton}
                                  >
                                    {t('actions.cancel')}
                                  </button>
                                </>
                              ) : showTypeSigners && !showSigners ? (
                                <>
                                  <p
                                    style={{
                                      margin: '0',
                                      fontSize: '20px',
                                      fontWeight: 'bold',
                                      fontFamily: 'Roboto',
                                      backgroundColor: '#bfbfbf',
                                      padding: '8px',
                                      borderRadius: '8px',
                                    }}
                                  >
                                    {t('actions.types_signers')}
                                  </p>
                                  {selectorTypes.map((type) => (
                                    <button
                                      type="button"
                                      key={type.id}
                                      onClick={() =>
                                        handleMenuOption(
                                          'selectTypeSigner',
                                          type,
                                        )
                                      }
                                      className={classes.addSignatureButton}
                                    >
                                      {type.name}
                                    </button>
                                  ))}
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleMenuOption('cancel');
                                    }}
                                    className={classes.cancelButton}
                                  >
                                    {t('actions.cancel')}
                                  </button>
                                </>
                              ) : (
                                <>
                                  <p
                                    style={{
                                      margin: '0',
                                      fontSize: '20px',
                                      fontWeight: 'bold',
                                      fontFamily: 'Roboto',
                                      backgroundColor: '#bfbfbf',
                                      padding: '8px',
                                      borderRadius: '8px',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {t('actions.select_signer')}
                                  </p>
                                  {signers.filter(
                                    (signer) =>
                                      signer.type === TYPE_MAP[typeAddSigner],
                                  ).length > 0 ? (
                                      signers
                                        .filter(
                                          (signer) =>
                                            signer.type === TYPE_MAP[typeAddSigner],
                                        )
                                        .map((signer) => (
                                          <button
                                            type="button"
                                            key={signer.id}
                                            onClick={() =>
                                              handleMenuOption(
                                                'selectSigner',
                                                signer,
                                              )
                                            }
                                            className={classes.addSignatureButton}
                                          >
                                            {signer.name}
                                          </button>
                                        ))
                                    ) : (
                                      <p
                                        style={{
                                          fontSize: '16px',
                                          fontFamily: 'Roboto',
                                          textAlign: 'center',
                                        }}
                                      >
                                        {t('messages.no_signers_available')}
                                      </p>
                                    )}
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowSigners(false); // Volver al menú anterior
                                      setShowTypeSigners(true);
                                    }}
                                    className={classes.cancelButton}
                                  >
                                    {t('actions.back')}
                                  </button>
                                </>
                              )}
                            </div>
                          )}
                          {signatures
                            .filter(
                              (signature) => signature.page === pageNumber,
                            )
                            .map((signature) => (
                              <div
                                key={signature.id}
                                style={{
                                  position: 'absolute',
                                  left: `${signature.relative_position_x}px`,
                                  top: `${signature.relative_position_y}px`,
                                  width: `${signature.relative_size_x || 90}px`,
                                  height: `${
                                    signature.relative_size_y || 40
                                  }px`,
                                  border: '2px dashed #007bff',
                                  backgroundColor: 'rgba(0, 123, 255, 0.1)',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '12px',
                                  color: '#007bff',
                                  cursor: 'grab', // Indicar que es arrastrable
                                  zIndex:
                                    draggingSignature === signature.id
                                      ? 20
                                      : 10,
                                  userSelect: 'none', // Evitar la selección de texto
                                }}
                                onMouseDown={(e) => {
                                  setDraggingSignature(signature.id);
                                  dragOffset.current = {
                                    relative_position_x:
                                      e.clientX - signature.relative_position_x,
                                    relative_position_y:
                                      e.clientY - signature.relative_position_y,
                                  };
                                }}
                                onClick={(e) => e.stopPropagation()} // Evitar que se cierre al hacer clic en la firma
                              >
                                {signature.name}
                                <div
                                  style={{
                                    position: 'absolute',
                                    bottom: '0',
                                    right: '0',
                                    width: '10px',
                                    height: '10px',
                                    backgroundColor: '#007bff',
                                    cursor: 'se-resize',
                                  }}
                                  onMouseDown={(e) =>
                                    handleResizeMouseDown(e, signature.id)
                                  }
                                />
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveSignature(signature.id);
                                  }}
                                  style={{
                                    position: 'absolute',
                                    top: '-10px',
                                    right: '-10px',
                                    backgroundColor: '#85929e',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  X
                                </button>
                              </div>
                            ))}
                        </Page>
                      </Document>
                    </div>
                  </Grid>
                  {/* Controles de zoom */}
                  <Grid item xs={12} className={classes.zoomControlsContainer}>
                    <button
                      type="button"
                      className={classes.zoomButton}
                      onClick={handleZoomOut}
                      disabled={pdfZoom <= 0.3}
                      title={t('actions.zoom_out') || 'Alejar'}
                    >
                      <ZoomOutIcon fontSize={isMobile ? 'small' : 'default'} />
                      {!isMobile && 'Alejar'}
                    </button>
                    <div className={classes.zoomInfo}>
                      {Math.round(pdfZoom * 100)}%
                    </div>
                    <button
                      type="button"
                      className={classes.zoomButton}
                      onClick={handleZoomIn}
                      disabled={pdfZoom >= 3.0}
                      title={t('actions.zoom_in') || 'Acercar'}
                    >
                      <ZoomInIcon fontSize={isMobile ? 'small' : 'default'} />
                      {!isMobile && 'Acercar'}
                    </button>
                    <button
                      type="button"
                      className={classes.zoomButton}
                      onClick={handleResetZoom}
                      title={t('actions.reset_zoom') || 'Tamaño original'}
                    >
                      <ZoomOutMapIcon
                        fontSize={isMobile ? 'small' : 'default'}
                      />
                      {!isMobile && 'Restablecer'}
                    </button>
                  </Grid>
                  <Grid item xs={12} className={classes.paginationContainer}>
                    <button
                      type="button"
                      className={classes.paginationButton}
                      onClick={handleBack}
                      disabled={pageNumber <= 1}
                      style={{
                        fontSize: isMobile ? '0.75rem' : '1rem',
                        padding: isMobile ? '8px 12px' : '12px 16px',
                      }}
                    >
                      {isMobile ? '‹' : t('actions.back_page')}
                    </button>
                    <span
                      style={{
                        fontSize: isMobile ? '0.8rem' : '1rem',
                        margin: isMobile ? '0 8px' : '0 16px',
                      }}
                    >
                      {isMobile
                        ? `${pageNumber}/${numPages}`
                        : `${t('actions.page')} ${pageNumber} ${t(
                          'actions.of',
                        )} ${numPages}`}
                    </span>
                    <button
                      type="button"
                      className={classes.paginationButton}
                      onClick={handleNext}
                      disabled={pageNumber >= numPages}
                      style={{
                        fontSize: isMobile ? '0.75rem' : '1rem',
                        padding: isMobile ? '8px 12px' : '12px 16px',
                      }}
                    >
                      {isMobile ? '›' : t('actions.next_page')}
                    </button>
                  </Grid>
                </Grid>
              )}
              {!readOnly && (
                <Modal
                  title={modal?.title}
                  open={modal?.open}
                  maxWidth={modal?.maxWidth}
                  events={{
                    onClose: () => handleModalClose(),
                  }}
                >
                  {modal?.view === 'addSigner' && (
                    <>
                      <ButtonGroup
                        actions={SIGNERS_BUTTON_GROUP}
                        onChange={(value) => {
                          setCurrentView(value);
                          setSelectorType(t('forms.selectors.select'));
                          setSelectorClient(t('forms.selectors.select'));
                          setSelectorRelationShip(t('forms.selectors.select'));
                        }}
                        pb={3}
                        pt={2}
                        value={currentView}
                        width={isMobile ? '100%' : 220}
                        color={'secondary'}
                      />
                      <Header
                        actions={[
                          {
                            color: 'secondary',
                            form: 'frmAddSigner',
                            icon: <SaveIcon />,
                            label: t('actions.save'),
                            type: 'submit',
                            processing: isLoading,
                            hidden: currentView !== 'add',
                          },
                        ]}
                        breadcrumb={false}
                        title={
                          currentView === 'add'
                            ? t('actions.create_signer')
                            : t('actions.list_signers')
                        }
                      />

                      {currentView === 'list' && (
                        <DataTable
                          actions={[
                            {
                              color: 'error',
                              icon: <DeleteTwoToneIcon />,
                              title: t('table.actions.delete_signer'),
                              fn: function ({ data }) {
                                setModal2({
                                  open: true,
                                  data,
                                });
                              },
                            },
                          ]}
                          total={table?.total ?? 0}
                          {...generateTable(
                            HEADERS.filter((header) => !header?.hidden),
                            table?.rows,
                          )}
                          mt={2}
                        />
                      )}

                      {currentView === 'add' && (
                        <>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <SelectControl
                                onChange={function ({ target }) {
                                  handleSelectorType(target);
                                }}
                                label={t('forms.signers.fields.type')}
                                settings={{
                                  emptyElement: t('forms.selectors.select'),
                                  options: selectorTypes.map(
                                    ({ id, name }) => ({
                                      id: id,
                                      name: name,
                                    }),
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              {selectorType === 2 && (
                                <SelectControl
                                  onChange={function ({ target }) {
                                    handleSelectorClient(target);
                                  }}
                                  key={selectorType}
                                  label={t('forms.signers.fields.templete')}
                                  settings={{
                                    emptyElement: t('forms.selectors.select'),
                                    options: selectorClients.map(
                                      ({ id, name }) => ({
                                        id: id,
                                        name: name,
                                      }),
                                    ),
                                  }}
                                />
                              )}
                              {selectorType === 3 && (
                                <SelectControl
                                  onChange={function ({ target }) {
                                    handleSelectorRelationships(target);
                                  }}
                                  key={selectorType}
                                  label={t('forms.signers.fields.relationship')}
                                  settings={{
                                    emptyElement: t('forms.selectors.select'),
                                    options: selectorRelationships.map(
                                      ({ id, name }) => ({
                                        id: id,
                                        name: name,
                                      }),
                                    ),
                                  }}
                                />
                              )}
                            </Grid>
                          </Grid>
                          {isProcessing === false && (
                            <DynamicForm
                              fields={[
                                {
                                  display: {
                                    breakpoints: {
                                      md: 6,
                                      sm: 12,
                                      xs: 12,
                                    },
                                  },
                                  type: 'divider',
                                  name: 'divider1',
                                },
                                {
                                  display: {
                                    breakpoints: {
                                      md: 6,
                                      sm: 12,
                                      xs: 12,
                                    },
                                  },
                                  label: t('forms.signers.fields.name'),
                                  name: 'name',
                                  type:
                                    selectorType !==
                                      t('forms.selectors.select') &&
                                    selectorType === 1
                                      ? 'text'
                                      : selectorType === 2 &&
                                        selectorClient !==
                                          t('forms.selectors.select')
                                        ? 'select'
                                        : selectorType === 3 &&
                                        selectorRelationShip !==
                                          t('forms.selectors.select')
                                          ? 'select'
                                          : 'hidden',
                                  settings: {
                                    autocomplete:
                                      (valuesClient || [])?.length > 10,
                                    emptyElement: t('forms.selectors.select'),
                                    options:
                                      filterValidClients(valuesClient) || [],
                                  },
                                },
                                {
                                  display: {
                                    breakpoints: {
                                      md: 6,
                                      sm: 12,
                                      xs: 12,
                                    },
                                  },
                                  label: t('forms.signers.fields.email'),
                                  name: 'email',
                                  type:
                                    selectorType !==
                                      t('forms.selectors.select') &&
                                    selectorType === 1
                                      ? 'text'
                                      : selectorType === 2 &&
                                        selectorClient !==
                                          t('forms.selectors.select')
                                        ? 'select'
                                        : selectorType === 3 &&
                                        selectorRelationShip !==
                                          t('forms.selectors.select')
                                          ? 'select'
                                          : 'hidden',
                                  settings: {
                                    autocomplete:
                                      (valuesClient || []).length > 10,
                                    emptyElement: t('forms.selectors.select'),
                                    options:
                                      filterValidClients(valuesClient) || [],
                                  },
                                },
                                {
                                  display: {
                                    breakpoints: {
                                      md: 6,
                                      sm: 12,
                                      xs: 12,
                                    },
                                  },
                                  label: t('forms.signers.fields.telefono'),
                                  name: 'telefono',
                                  type:
                                    selectorType !==
                                      t('forms.selectors.select') &&
                                    selectorType === 1
                                      ? 'text'
                                      : selectorType === 2 &&
                                        selectorClient !==
                                          t('forms.selectors.select')
                                        ? 'select'
                                        : selectorType === 3 &&
                                        selectorRelationShip !==
                                          t('forms.selectors.select')
                                          ? 'select'
                                          : 'hidden',
                                  settings: {
                                    autocomplete:
                                      (valuesClient || []).length > 10,
                                    emptyElement: t('forms.selectors.select'),
                                    options:
                                      filterValidClients(valuesClient) || [],
                                  },
                                },
                                {
                                  display: {
                                    breakpoints: {
                                      md: 6,
                                      sm: 12,
                                      xs: 12,
                                    },
                                  },
                                  label: t('forms.signers.fields.description'),
                                  name: 'description',
                                  type:
                                    selectorType !==
                                      t('forms.selectors.select') &&
                                    selectorType === 1
                                      ? 'text'
                                      : selectorType === 2 &&
                                          selectorClient !==
                                            t('forms.selectors.select')
                                        ? 'text'
                                        : selectorType === 3 &&
                                        selectorRelationShip !==
                                          t('forms.selectors.select')
                                          ? 'text'
                                          : 'hidden',
                                  disabled: readOnly,
                                },
                                {
                                  display: {
                                    breakpoints: {
                                      md: 12,
                                      sm: 12,
                                      xs: 12,
                                    },
                                  },
                                  type: 'space',
                                },
                              ]}
                              id="frmAddSigner"
                              initialValues={{
                                name: '',
                                email: '',
                                telefono: '',
                                description: '',
                              }}
                              handleSubmitData={handleSubmitData}
                              validationSchema={
                                selectorType === 1
                                  ? addSignerFormSchema
                                  : selectorType === 2
                                    ? addSignerFormSchemaClient
                                    : addSignerFormSchemaRelationship
                              }
                            />
                          )}
                        </>
                      )}
                    </>
                  )}
                </Modal>
              )}
              {!readOnly && (
                <Modal
                  children={
                    <>
                      {t('forms.messages.signer_deleting_question')}{' '}
                      <b>{modal2?.data?.name}</b>?
                    </>
                  }
                  open={modal2?.open}
                  title={t('actions.delete_signer')}
                  actions={[
                    {
                      color: 'error',
                      label: t('actions.yes'),
                      fn: async function () {
                        handleRemoveSigner(modal2?.data?.id);
                      },
                    },
                  ]}
                  events={{
                    onClose: () => setModal2(),
                  }}
                />
              )}
            </Box>
          </Grid>

          {openSidebar && !readOnly && (
            <Grid item md={4} xs={12}>
              <Box
                className={classes.boxContainer}
                style={{
                  width: '100%',
                }}
              >
                <IconButton onClick={handleSidebarToggle}>
                  <CloseIcon />
                </IconButton>
                <Tabs
                  value={tabIndex}
                  onChange={(e, newValue) => setTabIndex(newValue)}
                  centered
                >
                  <Tab label={t('actions.label')} />
                  <Tab label={t('actions.help')} />
                </Tabs>
                <Box
                  sx={{
                    marginTop: 16,
                  }}
                >
                  {tabIndex === 0 && (
                    <>
                      {data && labelsMatch && Object.keys(labelsMatch).length > 0 && (
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          alignItems="center"
                          py={3}
                          px={2}
                          bgcolor="#e0f7fa"
                          borderRadius={2}
                          boxShadow={1}
                          mb={2}
                        >
                          <Typography
                            variant="body1"
                            align="center"
                            color="textPrimary"
                          >
                            {t('messages.labels_found_one')}
                          </Typography>
                          <Typography
                            variant="body2"
                            align="center"
                            color="textSecondary"
                          >
                            {t('messages.labels_found_two')}
                          </Typography>
                        </Box>
                      )}
                      {data && labelsMatch && Object.keys(labelsMatch).length > 0 ? (
                        Object.keys(labelsMatch)
                          .sort()
                          .map((key) => {
                            const cleanedKey = cleanString(key);
                            return (
                              <DynamicForm
                                key={key}
                                container="card"
                                initialValues={{
                                  [cleanedKey]: labelsMatch[key] ? cleanTemplate(labelsMatch[key]) : '',
                                  [`functions_${cleanedKey}`]:
                                    fieldFunction[key] || [],
                                }}
                                fields={[
                                  {
                                    label: key,
                                    type: 'divider',
                                  },
                                  {
                                    display: {
                                      breakpoints: {
                                        md: 9,
                                        sm: 9,
                                        xs: 9,
                                      },
                                    },
                                    events: {
                                      onChange: ({ value }) => {
                                        setLabels((prevLabels) => ({
                                          ...prevLabels,
                                          [key]: value,
                                        }));
                                        setLabelsMatch((prevLabels) => ({
                                          ...prevLabels,
                                          [key]: value,
                                        }));
                                      },
                                    },
                                    label: 'Campos',
                                    name: cleanedKey,
                                    settings: {
                                      emptyElement: 'Selecciona',
                                      autocomplete: true,
                                      tree: true,
                                      options: data,
                                    },
                                    type: 'select',
                                  },
                                  {
                                    name: 'showFunctions',
                                    type: 'switch',
                                    events: {
                                      onChange: ({ value }) => {
                                        setOpenFunctions((prev) => ({
                                          ...prev,
                                          [cleanedKey]: !prev[cleanedKey],
                                        }));
                                      },
                                    },
                                    IconStateOne: openFunctions[cleanedKey]
                                      ? CloseIcon
                                      : PlaylistAddIcon,
                                    IconStateTwo: openFunctions[cleanedKey]
                                      ? CloseIcon
                                      : PlaylistAddIcon,
                                    tooltipStateOne: openFunctions[cleanedKey]
                                      ? t('actions.collapse')
                                      : t('actions.expand'),
                                    tooltipStateTwo: openFunctions[cleanedKey]
                                      ? t('actions.collapse')
                                      : t('actions.expand'),
                                    display: {
                                      variant: 'button',
                                      breakpoints: {
                                        md: 3,
                                        sm: 3,
                                        xs: 3,
                                      },
                                    },
                                  },
                                  {
                                    label: 'Funciones',
                                    name: `functions_${cleanedKey}`,
                                    type: !openFunctions[cleanedKey]
                                      ? 'hidden'
                                      : 'multiselecttag',
                                    settings: {
                                      options: functions?.map((option) => ({
                                        id: option.id,
                                        name: option.name,
                                        description: option.description,
                                      })),
                                    },
                                    display: {
                                      breakpoints: {
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      },
                                    },
                                    events: {
                                      onChange: ({ value }) => {
                                        setFieldFunction((prevFunctions) => ({
                                          ...prevFunctions,
                                          [key]: value,
                                        }));
                                      },
                                    },
                                  },
                                ]}
                              />
                            );
                          })
                      ) : (
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          alignItems="center"
                          py={3}
                          px={2}
                          bgcolor="#f5f5f5"
                          borderRadius={2}
                          boxShadow={1}
                        >
                          <Typography
                            variant="body1"
                            align="center"
                            color="textSecondary"
                          >
                            {t('messages.lables_not_found_one')}
                          </Typography>
                          <Typography
                            variant="body2"
                            align="center"
                            color="textSecondary"
                          >
                            {t('messages.lables_not_found_one')}
                          </Typography>
                        </Box>
                      )}
                      {pdfFile && (
                        <>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-end"
                            mt={2}
                            px={2}
                          >
                            {isAdding ? (
                              <>
                                <TextField
                                  label={t('forms.selectors.new_field')}
                                  variant="outlined"
                                  size="small"
                                  value={newLabel}
                                  onChange={(e) => setNewLabel(e.target.value)}
                                  autoFocus
                                  onKeyDown={(e) =>
                                    e.key === 'Enter' && handleAddLabel()
                                  }
                                  onBlur={() => setIsAdding(false)}
                                />
                                <Tooltip title={t('actions.add')}>
                                  <IconButton
                                    color="primary"
                                    onClick={handleAddLabel}
                                    sx={{
                                      ml: 1,
                                    }}
                                  >
                                    <AddIcon />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : (
                              <Tooltip title={t('actions.add_field')}>
                                <IconButton
                                  color="primary"
                                  onClick={() => setIsAdding(true)}
                                >
                                  <AddIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </>
                      )}
                    </>
                  )}
                  {tabIndex === 1 && (
                    <>
                      <Box>
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="h6"
                              style={{
                                marginBottom: 16,
                              }}
                            >
                              {t('messages.question_one')}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              <Stepper orientation="vertical">
                                {stepsQuestion1.map((label, index) => (
                                  <Step
                                    key={index}
                                    active={true}
                                    completed={stepsCompleted[index]}
                                  >
                                    <StepLabel
                                      optional={
                                        index === 3 ? (
                                          <Typography variant="caption">
                                            {t('messages.optional')}
                                          </Typography>
                                        ) : null
                                      }
                                    >
                                      <Typography variant="body2">
                                        {label}
                                      </Typography>
                                    </StepLabel>
                                  </Step>
                                ))}
                              </Stepper>
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">
                              {t('messages.question_two')}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box>
                              <p className={classes.helper}>
                                {t('messages.answer_quest_two')}
                              </p>
                              <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                py={3}
                                px={2}
                                bgcolor="#e3f2fd"
                                borderRadius={2}
                                boxShadow={1}
                              >
                                <p className={classes.helper}>
                                  {t('messages.example')}{' '}
                                  <strong>{`{{${t('messages.example_field')}}}`}</strong>
                                </p>
                              </Box>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">
                              {t('messages.question_three')}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Stepper orientation="vertical">
                              {stepsQuestion2.map((step, index) => (
                                <Step key={index} active={true}>
                                  <StepLabel icon={step.icon}>
                                    <Typography variant="body2">
                                      {step.label}
                                    </Typography>
                                  </StepLabel>
                                </Step>
                              ))}
                            </Stepper>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
}

FileAndHtmlControl.defaultProps = DEFAULT_PROPS;
FileAndHtmlControl.propTypes = PROP_TYPES;

export default FileAndHtmlControl;
